import { Component, Input } from '@angular/core';

@Component({
  selector: 'app-tracking-page-status-text',
  template: `
    <span> {{ 'description_' + status | translate }} </span>
  `
})
export class TrackingPageStatusTextComponent {
  @Input() status: string;
}
